import Cookies from 'js-cookie'
import {
  AUTH_COOKIE,
  TOKEN_COOKIE,
  LOGIN_CHECK_COOKIE,
  BEU_LOGIN_CHECK_COOKIE,
  BEU_LOGIN_FIRST_COOKIE, BEU_HOST_USER_COOKIE
} from '@/libs/constants'

function requestTokenFromParent (key) {
  return new Promise((resolve, reject) => {
    function messageHandler (event) {
      if (event.data.type === '_BEU_RESPONSE_DATA') {
        // window.removeEventListener('message', messageHandler)
        resolve(event.data.value)
      }
    }

    window.addEventListener('message', messageHandler)

    // 부모에게 토큰 요청
    window.parent.postMessage({ type: '_BEU_GET_DATA', key: key }, '*')

    // 필요하면 타임아웃도 걸기
    setTimeout(() => {
      // window.removeEventListener('message', messageHandler)
      reject(new Error('토큰 요청 응답 없음'))
    }, 3000)
  })
}

function isInIframe () {
  try {
    return window.self !== window.top
  } catch (e) {
    return true
  }
}

const CommonStorage = {
  setItem: function (key, value, options = {}) {
    if (isInIframe()) {
      const expiresInMs = options.expires
        ? (options.expires instanceof Date ? options.expires.getTime() - new Date().getTime() : options.expires) : null

      const now = new Date().getTime()
      const item = {
        value: value,
        expires: expiresInMs ? now + expiresInMs : null
      }

      try {
        localStorage.setItem(key, JSON.stringify(item))
        return true
      } catch (e) {
        console.warn('localStorage not available:', e)
        return false
      }
    } else {
      try {
        const cookieOptions = {
          path: options.path || '/'
        }
        if (options.domain) {
          cookieOptions.domain = options.domain
        }
        if (options.expires) {
          cookieOptions.expires = options.expires
        }
        Cookies.set(key, value, cookieOptions)
        return true
      } catch (e) {
        console.warn('Cookie not available:', e)
        return false
      }
    }
  },

  getItem: function (key) {
    if (isInIframe()) {
      try {
        const itemStr = localStorage.getItem(key)
        if (!itemStr) return null

        const item = JSON.parse(itemStr)
        const now = new Date().getTime()

        if (item.expires && now > item.expires) {
          localStorage.removeItem(key)
          return null
        }

        return item.value
      } catch (e) {
        console.warn('Error reading from localStorage:', e)
        return null
      }
    } else {
      try {
        return Cookies.get(key) || null
      } catch (e) {
        console.warn('Error reading cookie:', e)
        return null
      }
    }
  },

  removeItem: function (key, options = {}) {
    if (isInIframe()) {
      try {
        localStorage.removeItem(key)
        return true
      } catch (e) {
        console.warn('Error removing from localStorage:', e)
        return false
      }
    } else {
      try {
        const cookieOptions = {
          path: options.path || '/'
        }
        if (options.domain) {
          cookieOptions.domain = options.domain
        }
        Cookies.remove(key, cookieOptions)
        return true
      } catch (e) {
        console.warn('Error removing cookie:', e)
        return false
      }
    }
  },

  cleanup: function () {
    if (!isInIframe()) return 0

    try {
      const now = new Date().getTime()
      const keysToRemove = []

      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i)
        const itemStr = localStorage.getItem(key)

        if (itemStr) {
          try {
            const item = JSON.parse(itemStr)
            if (item.expires && now > item.expires) {
              keysToRemove.push(key)
            }
          } catch (e) {
            // JSON 파싱 실패한 아이템은 무시
          }
        }
      }

      keysToRemove.forEach(key => localStorage.removeItem(key))
      return keysToRemove.length
    } catch (e) {
      console.warn('Error during localStorage cleanup:', e)
      return 0
    }
  }
}

function removeAuthToken () {
  CommonStorage.removeItem(TOKEN_COOKIE.name, {
    path: TOKEN_COOKIE.path,
    domain: TOKEN_COOKIE.domain
  })
}

export function getAuthToken () {
  return CommonStorage.getItem(TOKEN_COOKIE.name)
}

function removeAuthCookie () {
  CommonStorage.removeItem(AUTH_COOKIE.name, {
    path: AUTH_COOKIE.path,
    domain: AUTH_COOKIE.domain
  })
}

export function removeAuthData () {
  removeAuthToken()
  removeAuthCookie()

  removeLoginCheckCookie()
  removeBeuLoginCheckCookie()
  removeBeuFirstLoginCookie()
  removeBeuHostUserCookie()
}

export function setLoginCheckCookie (value = 'Y', expires) {
  CommonStorage.setItem(LOGIN_CHECK_COOKIE.name, value, {
    expires: expires,
    path: LOGIN_CHECK_COOKIE.path,
    domain: LOGIN_CHECK_COOKIE.domain
  })
}

function removeLoginCheckCookie () {
  CommonStorage.removeItem(LOGIN_CHECK_COOKIE.name, {
    path: LOGIN_CHECK_COOKIE.path,
    domain: LOGIN_CHECK_COOKIE.domain
  })
}

export function getLoginCheckCookie () {
  return CommonStorage.getItem(LOGIN_CHECK_COOKIE.name)
}

function removeBeuLoginCheckCookie () {
  CommonStorage.removeItem(BEU_LOGIN_CHECK_COOKIE.name, {
    path: BEU_LOGIN_CHECK_COOKIE.path,
    domain: BEU_LOGIN_CHECK_COOKIE.domain
  })
}

function removeBeuFirstLoginCookie () {
  CommonStorage.removeItem(BEU_LOGIN_FIRST_COOKIE.name, {
    path: BEU_LOGIN_FIRST_COOKIE.path,
    domain: BEU_LOGIN_FIRST_COOKIE.domain
  })
}

function removeBeuHostUserCookie () {
  CommonStorage.removeItem(BEU_HOST_USER_COOKIE.name, {
    path: BEU_HOST_USER_COOKIE.path,
    domain: BEU_HOST_USER_COOKIE.domain
  })
}

export { isInIframe, CommonStorage, requestTokenFromParent }
